import { defineComponent as a, computed as o, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "8e49652b-2223-4d47-b78f-c6544e7b4707" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#8e49652b-2223-4d47-b78f-c6544e7b4707)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "m0 378.5 254.1-22.1L512 378.5V512H0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m0 256.1 255-30.3 257 30.3v122.4H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#338af3",
  d: "M0 0h512v256H0z"
}, null, -1), w = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m289.4 150 31.3 14.6L304 195l34-6.5 4.3 34.3 23.6-25.2 23.7 25.2 4.3-34.3 34 6.5-16.7-30.3 31.2-14.7-31.2-14.7 16.6-30.3-34 6.5-4.2-34.3-23.7 25.3-23.6-25.3-4.3 34.3-34-6.5 16.7 30.3z"
}, null, -1), x = { fill: "none" }, b = ["r"], B = /* @__PURE__ */ a({
  __name: "rw",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, z) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), c("title", p, d(t.flagName), 1)) : f("", !0),
        k,
        v,
        g,
        w
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=rw-2b4c9e26.js.map
